import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ReactComponent as DefaultDatabaseLogo } from '../../../assets/eplass.logo.small.svg';
import { IAppReduxStore } from '../../../redux/store';
import { vars } from '../../../Theme';

/**
 * Component that shows the user's Auth0 profile image and allows them to manage and/or log out of their account.
 */
export default (props: { size: number }) => {
    /** Get relevant values from Redux store. */
    const metadata = useSelector((store: IAppReduxStore) => store.projectMetadata.data);

    /** Get the replicaId from the react router. */
    const { replicaId } = useParams();

    /** Deconstruct props. */
    const { size } = props;

    /** Configure image styles. */
    const imgStyles: React.CSSProperties = {
        backgroundColor: vars.bgGray,
        borderRadius: 5,
        height: size,
        width: size,
    };

    if (metadata[replicaId]?.Icon) {
        return <img src={metadata[replicaId].Icon} style={imgStyles} />;
    }

    return <DefaultDatabaseLogo style={imgStyles} />;
};
